module.exports = __webpack_public_path__ + "img/l-4.3a69ec90.png";